'use strict';

require('./src/assets/scss/init.scss');
require('./static/css/prismjs/theme.min.css');
require('./static/css/prismjs/prism-gruvbox-dark.css');
require('./static/css/my-css.css');